import React, { useContext } from "react";
import { useMediaQuery } from "react-responsive";
import { ScreenContext } from "../../../contexts/ScreenContext";
import { ReactComponent as BackArrow } from "../../../assets/mobile-back-arrow.svg";
import { ReactComponent as BackArrowMobile } from "../../../assets/back-icon-mobile.svg";
import { ReactComponent as CloseModalIcon } from "../../../assets/x.svg";
import Input from "./Input";
import styles from "./Header.module.css";
import { useTranslation } from "react-i18next";

const Header = (props) => {
  const { t } = useTranslation("stock")

  const { smallScreen, mediumScreen, largeScreen } = useContext(ScreenContext);
  const smScreen = useMediaQuery(smallScreen);
  const mdScreen = useMediaQuery(mediumScreen);
  const lgScreen = useMediaQuery(largeScreen);

  let tallHeader = true;
  let fullBottomBorderRadius = props.showFullBottomBorderRadius;

  if (props.smartLocation || (!smScreen && !props.useInput)) {
    tallHeader = false;
  }
  let headerStyles;

  if (!tallHeader && !fullBottomBorderRadius) {
    headerStyles = [styles["header"], styles["header--short"]].join(" ");
  } else if (!tallHeader && fullBottomBorderRadius) {
    headerStyles = [
      styles["header"],
      styles["header--short"],
      styles["header--fullBottomBorderRadius"],
    ].join(" ");
  } else if (tallHeader && fullBottomBorderRadius) {
    headerStyles = [
      styles["header"],
      styles["header--fullBottomBorderRadius"],
    ].join(" ");
  } else {
    headerStyles = styles.header;
  }

  return smScreen ? (
    <div className={styles.header}>
      <div className={styles.backArrow} onClick={props.backArrowHandler}>
        <BackArrowMobile className={styles.backArrow__icon} />
        <p className={styles.goBackTitle}>{t("backButtonLabel")}</p>
      </div>

      <h1 className={styles.headerTitle}>{props.headerTitle}</h1>
      {props.useInput && !props.smartLocation && (
        <div className={styles.inputContainer}>
          <Input
            inputFields={props.inputFields}
            enforceFocus={props.inputExtras.enforceFocus}
            blankInput={props.inputExtras.blankInput}
            onSetBlankInput={props.inputExtras.onSetBlankInput}
            onInputValue={props.onInputValue}
          />
        </div>
      )}
    </div>
  ) : (
    <div className={headerStyles}>
      <div className={styles.headerTitleGroup}>
        <BackArrow
          onClick={props.backArrowHandler}
          className={styles.backArrow}
        />

        <CloseModalIcon
          className={styles.closeModalIcon}
          onClick={props.onHideModal}
        />

        <span className={styles.headerTitle}>{props.headerTitle}</span>
      </div>
      {props.useInput && !props.smartLocation && (
        <div className={styles.inputContainer}>
          <Input
            inputFields={props.inputFields}
            enforceFocus={props.inputExtras.enforceFocus}
            blankInput={props.inputExtras.blankInput}
            onSetBlankInput={props.inputExtras.onSetBlankInput}
            onInputValue={props.onInputValue}
          />
        </div>
      )}
    </div>
  );
};

export default Header;
